function l(n) {
  return n.changedTouches ? n.changedTouches[0] : n;
}
function d(n, e) {
  var o;
  return function () {
    for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
      r[_key] = arguments[_key];
    }
    var i = function i() {
      return n.apply(void 0, r);
    };
    o && clearTimeout(o), o = setTimeout(i, e && e > 0 ? e : 300);
  };
}
function a() {
  if (!window) return !1;
  var n = window.matchMedia("(any-pointer:coarse)").matches,
    e = window.matchMedia("(any-pointer:fine)").matches;
  return n && !e;
}
function f() {
  if (!window || !navigator) return !1;
  var n = t();
  return /iPhone|iPod/i.test(n) || s();
}
function s() {
  if (!window || !navigator) return !1;
  var n = t();
  return /iPad/i.test(n) ? !0 : /Macintosh/i.test(n) && a();
}
function m() {
  return !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
}
function w() {
  if (!window || !navigator) return !1;
  var n = t();
  return /firefox/i.test(n);
}
var b = function b() {
  return /apple/i.test(navigator.vendor);
};
function p() {
  var n = document.documentElement.getAttribute("dir");
  return n !== null && n === "rtl";
}
function g() {
  return !u();
}
function u() {
  return window ? window.matchMedia && window.matchMedia("(orientation: portrait)").matches : !1;
}
var c = function c() {
    if (!window) return !1;
    var n = t();
    return /android|sink/i.test(n);
  },
  x = function x() {
    if (!window) return !1;
    var n = t();
    return c() && !/mobile/i.test(n);
  },
  t = function t() {
    return navigator.userAgent || navigator.vendor || window.opera;
  };
export { l as a, d as b, a as c, f as d, s as e, m as f, w as g, b as h, p as i, g as j, u as k, c as l, x as m };